import { z } from 'zod'

/**
 * 앱 오류 화면(RouteError)이 서버에 보내는 짧은 신고 (2026-10-17, 1.0.4~ 앱). 운영자 텔레그램 알림용.
 * 오류 메시지·스택·사용자 정보는 보내지 않는다 — 어느 경계에서 어떤 종류의 오류가 났는지만. 자세한 스택은 Sentry 에 있다.
 */
export const CLIENT_ERROR_BOUNDARIES = ['root', 'app', 'create', 'result'] as const
export type ClientErrorBoundary = (typeof CLIENT_ERROR_BOUNDARIES)[number]

export const clientErrorReportSchema = z.object({
  boundary: z.enum(CLIENT_ERROR_BOUNDARIES),
  /** 오류 이름 (TypeError 등). 영문·숫자만, 40자 */
  kind: z
    .string()
    .max(40)
    .regex(/^[A-Za-z0-9_$]*$/)
    .transform((v) => v || 'Error'),
  /** 코드가 OTA 로 바뀌었는지 — 내장 번들이면 true */
  embedded: z.boolean().optional(),
})
export type ClientErrorReport = z.infer<typeof clientErrorReportSchema>
